<kodit-dropdown
  [options]="items"
  [formCtrl]="godinaCtrl"
  (optionChanged)="handleOnItemChange($event)"
>
</kodit-dropdown>
